import React from 'react';
import './style/index.scss';
import { questionMap, QuestionOperateConfig } from './components';
import { QuestionOperateType, TemplateType, IOperateConfig } from '../../interface/multiCapabilityTemplate';
import { onWeights } from '../../dataFlow';
import { QuestionListProps } from './interface';
import { QuestionElement } from './components/questionElement';
interface IProps extends QuestionListProps {
    operateConfig: IOperateConfig;
    isValid: boolean;
}
const QuestionList = (props: IProps) => {
    const {
        list,
        mode,
        operateConfig,
        templateType,
        externalList = [],
        isValid,
        internalList = [],
        onCommunication,
    } = props;
    const isEnterprise = templateType === TemplateType.ENTERPRISE;
    const weightsList = isEnterprise
        ? list.map((item) => {
              return { weights: Number(item.weights) };
          })
        : [];
    const renderContent = () => {
        return list.map((item, index) => {
            const weights = isEnterprise ? onWeights(Number(item.weights), weightsList) : '';
            const { components: Element, label = '' } = questionMap[item.type];
            const onItemCommunication = (act: QuestionOperateType, data: any) => {
                return onCommunication(act, {
                    ...data,
                    index,
                });
            };
            return (
                <li key={item.id} className="template-question-item">
                    <QuestionOperateConfig
                        operateConfig={operateConfig}
                        currentIndex={index}
                        onCommunication={onCommunication}
                    >
                        <QuestionElement
                            mode={mode}
                            externalList={externalList}
                            info={item}
                            isValid={isValid}
                            suffixLabel={label}
                            internalList={internalList}
                            templateType={templateType}
                            weights={weights}
                            onCommunication={onItemCommunication}
                        >
                            {Element && (
                                <Element
                                    mode={mode}
                                    info={item}
                                    isValid={isValid}
                                    weights={weights}
                                    templateType={templateType}
                                    onCommunication={onItemCommunication}
                                />
                            )}
                        </QuestionElement>
                    </QuestionOperateConfig>
                </li>
            );
        });
    };
    return <ul className={`template-question-list template-question-${templateType}`}>{renderContent()}</ul>;
};
export { QuestionList };
